module.exports = __webpack_public_path__ + "img/icon-result.641cf2df.png";